if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    slider = undefined;
    options = {
      slidesPerPage: 1,
      rewind: true,
      draggable: true,
      autoplay: true,
    };
    selectors = {
      slider: '.swiper',
      prev: '[data-arrow-prev]',
      next: '[data-arrow-next]',
    };
    breakpoint = window.matchMedia('(max-width: 989px)');

    constructor() {
      super();
    }

    initSlider() {
      this.options.navigation = {
        prevEl: this.selectors.prev,
        nextEl: this.selectors.next,
      };

      const swiperEl = this.querySelector(this.selectors.slider);
      if (!swiperEl) {
        return;
      }

      this.slider = new Swiper(swiperEl, this.options);
    }

    connectedCallback() {
      this.initSlider();
      this.setVariable();

      this.breakpoint.addEventListener('change', this.setVariable.bind(this));
    }

    setVariable() {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${parseInt(this.offsetHeight || 0)}px`,
      );
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);
}
